var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui segment" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("name")]),
      _vm._v(
        "\n    : " +
          _vm._s(
            _vm.getI18n(
              _vm.observationsDetail[0].observation.observedProperty.name,
              "en"
            )
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "ui celled table" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.observationsDetail, function(obs, index) {
          return _c("tr", { key: index }, [
            _c("td", { attrs: { "data-label": index } }, [
              _vm._v(_vm._s(index + 1))
            ]),
            _vm._v(" "),
            _c("td", { attrs: { "data-label": "Producer name" } }, [
              _vm._v(
                _vm._s(_vm.getI18n(obs.observation.observedProperty.name, "en"))
              )
            ]),
            _vm._v(" "),
            _c("td", { attrs: { "data-label": "Unit" } }, [
              _vm._v(
                _vm._s(_vm.getI18n(obs.observation.observedProperty.unit, "en"))
              )
            ]),
            _vm._v(" "),
            _c("td", { attrs: { "data-label": "Temporal extent" } }, [
              _vm._v(
                "\n          " +
                  _vm._s(obs.observation.temporalExtent.dateBeg) +
                  "\n          "
              ),
              _c("br"),
              _vm._v(
                "\n          " +
                  _vm._s(obs.observation.temporalExtent.dateEnd) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              obs.observation.observedProperty.description != null
                ? _c("div", { attrs: { "data-label": "Description" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.getI18n(
                          obs.observation.observedProperty.description,
                          "en"
                        )
                      )
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("td", { attrs: { "data-label": "GCMD" } }, [
              obs.observation.observedProperty.gcmdKeywords != null
                ? _c("div", [
                    obs.observation.observedProperty.gcmdKeywords != null
                      ? _c(
                          "div",
                          _vm._l(_vm.observedProperty.gcmdKeywords, function(
                            gcmd,
                            index
                          ) {
                            return _c("div", { key: index }, [
                              gcmd.category
                                ? _c("span", [_vm._v(_vm._s(gcmd.category))])
                                : _vm._e(),
                              _vm._v(" "),
                              gcmd.topic
                                ? _c("span", [
                                    _vm._v("> " + _vm._s(gcmd.topic))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              gcmd.term
                                ? _c("span", [_vm._v("> " + _vm._s(gcmd.term))])
                                : _vm._e(),
                              _vm._v(" "),
                              gcmd.variableLevel1
                                ? _c("span", [
                                    _vm._v("> " + _vm._s(gcmd.variableLevel1))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              gcmd.variableLevel2
                                ? _c("span", [
                                    _vm._v("> " + _vm._s(gcmd.variableLevel2))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              gcmd.variableLevel3
                                ? _c("span", [
                                    _vm._v("> " + _vm._s(gcmd.variableLevel3))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              gcmd.uuid
                                ? _c("span", [_vm._v("> " + _vm._s(gcmd.uuid))])
                                : _vm._e()
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("td", { attrs: { "data-label": "Data access" } }, [
              obs.observation.result.dataFile.name.length != 0
                ? _c("div", [_vm._m(2, true)])
                : _vm._e()
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "info circle icon" }),
      _vm._v("Variables:\n  ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Producer variable name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Unit")]),
        _vm._v(" "),
        _c("th", [
          _c("i", { staticClass: "calendar check outline icon" }),
          _vm._v(" Temporal extent\n        ")
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Description")]),
        _vm._v(" "),
        _c("th", [_vm._v("GCMD")]),
        _vm._v(" "),
        _c("th", [
          _c("i", { staticClass: "database icon" }),
          _vm._v(" Data access\n        ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ui animated button", attrs: { tabindex: "0" } },
      [
        _c("div", { staticClass: "visible content" }, [_vm._v("Download")]),
        _vm._v(" "),
        _c("div", { staticClass: "hidden content" }, [
          _c("i", { staticClass: "save icon" })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }